module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTDZ2/zp0/zp2/zx2/zx0/zp0/z5u/zx2/zx2/zx0/zp2/zp2/zx2/zp2/zx2/zx2/zx2/2C0OioAAAARdFJOUwAgMLDwUIAQ4NGhwXCRQGCfBJrn4gAAAG1JREFUGNNl0EkOwCAIBVCcQKNt5f6XrUOrpfyNyYsMAcA4riASPDMHQakJe/oSj1yagiosotfRJMqJVhNktQQYtQQANks/c72d7X19PCfRWASNie1x8z9l3klPbd3k10HiS7hmEE6Usy0etRDcKswHJjyQ6agAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-popver-phone-active.png
// module id = 1UOE
// module chunks = 34